<template>
  <div class="lesson-text-content">
    <!-- If a VBibleInteractive renderer is provided by the app, use it.
         Otherwise fall back to plain v-html (no interactive Bible refs). -->
    <component
      v-if="renderHtml"
      :is="renderHtml"
      :html="text ?? ''"
    />
    <div v-else v-html="text" />
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue';

defineProps<{
  text?: string;
}>();

// Apps can provide a VBibleInteractive-compatible component via:
//   provide('vllRenderHtml', VBibleInteractive)
// If not provided, falls back to v-html.
const renderHtml = inject<object | null>('vllRenderHtml', null);
</script>

<style scoped>
.lesson-text-content {
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-primary);
  margin: 0;
  padding: 0;
  display: block;
  max-width: 100%;
  white-space: pre-wrap;
  word-break: break-word;
}

.lesson-text-content :deep(b),
.lesson-text-content :deep(strong) {
  font-weight: 600;
}
</style>
